/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {ReferenceEntity} from '../models/ReferenceEntity';
import type {ReferenceEntityType} from '../models/ReferenceEntityType';

export interface RunCrossReferenceSearch$Request {
    searchByName: string;
    entityType: ReferenceEntityType;
}

export interface RunCrossReferenceSearch$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const runCrossReferenceSearchRequest = createAction<PayloadData<void, RunCrossReferenceSearch$Request>>('RUN_CROSS_REFERENCE_SEARCH__RUN_CROSS_REFERENCE_SEARCH__REQUEST');
export const runCrossReferenceSearchSuccess = createAction<PayloadData<Array<ReferenceEntity>, RunCrossReferenceSearch$Request>>('RUN_CROSS_REFERENCE_SEARCH__RUN_CROSS_REFERENCE_SEARCH__SUCCESS');
export const runCrossReferenceSearchFailure = createAction<PayloadData<Error, RunCrossReferenceSearch$Request, true>>('RUN_CROSS_REFERENCE_SEARCH__RUN_CROSS_REFERENCE_SEARCH__FAILURE');

export const runCrossReferenceSearchActions = [
    runCrossReferenceSearchRequest,
    runCrossReferenceSearchSuccess,
    runCrossReferenceSearchFailure
] as const;

/**
 * @param {string} meta.searchByName
 * @param {ReferenceEntityType} meta.entityType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const runCrossReferenceSearch = (meta: RunCrossReferenceSearch$Request, config?: RunCrossReferenceSearch$Config) => {
    const TRANSPORT_GET_PARAMS = {
        searchByName: meta.searchByName,
        entityType: meta.entityType,
    };
    return {
        CALL_API: {
            types: runCrossReferenceSearchActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/cross-reference/search`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

